<div class="banner {{ status }} {{ layout }} {{ accent }}">
  <capra-status-icon *ngIf="showIcon" class="status-icon" [status]="status"></capra-status-icon>
  <div>
    <ng-content></ng-content>
  </div>
</div>
